import {
    FETCH_CHAT_ACCESS_TOKEN_SUCCESS,
    FETCH_VIDEO_ACCESS_TOKEN_SUCCESS
} from "../actions/ActionTypes"
import initialState from "./InitialState"

export const ChatAndVideoAccessTokenReducer = (state = initialState.chatAndVideoAccessTokens, action: any) => {
    switch (action.type) {
        case FETCH_CHAT_ACCESS_TOKEN_SUCCESS:
            return { ...state, chatAccessToken: action.chatAccessToken }
        case FETCH_VIDEO_ACCESS_TOKEN_SUCCESS:
            return { ...state, videoAccessToken: action.videoAccessToken };
        default:
            return state;
    }
};